import { useMuiNavHeight } from "src/hooks/use-mui-nav-height";
import { useIsCallerContentApp } from "src/lib/native-bridge/hooks/use-is-content-app";
import { TResponsivePx } from "src/types/responsive";

const NO_NAV_HEIGHT: TResponsivePx = { xs: 0 };

export const useStickyNavHeight = (): TResponsivePx => {
    const isCallerContentApp = useIsCallerContentApp();
    const { NAV_HEIGHT_VARIATION } = useMuiNavHeight();

    return isCallerContentApp ? NO_NAV_HEIGHT : NAV_HEIGHT_VARIATION;
};
